<script setup lang="ts">
import {Avatar, Button} from "@/Components/Library";
import {useMainStore} from "@/Stores/store";

const $store = useMainStore();
const props = withDefaults(defineProps<{contact: any; showMenu?: boolean}>(), {
    showMenu: true,
});
const emit = defineEmits(["menu", "show"]);
</script>
<template>
    <div class="flex">
        <button type="button" class="flex grow items-center gap-2 py-4 text-sm" @click="emit('show', contact)">
            <Avatar
                :user="contact"
                class="flex h-8 w-8 shrink-0"
                :class="[`bg-${contact.profile?.color?.class ?? 'stone-300'}`]"
                shape="circle"
            />
            <div>
                <span class="font-medium">{{ contact.first_name }}</span>
                <span class="ml-1.5 font-bold">{{ contact.last_name }}</span>
            </div>
        </button>
        <Button
            type="button"
            v-if="showMenu"
            :icon="{
                icon: 'pepicons-pencil:dots-y',
                width: '24',
            }"
            class="!pr-3 !ring-0"
            @click.stop="emit('menu', $event, contact)"
        />
    </div>
</template>
<style scoped></style>
